import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetTeamsQuery } from "../features/teams/teamsApi";
import { useGetProjectsQuery } from "../features/projects/projectsApi";
import { useAddTaskMutation } from "../features/tasks/tasksApi";

const AddTaskForm = () => {
  const { data: teams } = useGetTeamsQuery();
  const { data: projects } = useGetProjectsQuery();

  const [task, setTask] = useState({
    taskName: "",
    teamMember: "",
    projectName: "",
    deadline: "",
  });

  const [responseError, setResponseError] = useState("");

  const [addTask, { isLoading, isError }] = useAddTaskMutation();

  const navigate = useNavigate();

  let teamMember = {};
  let project = {};

  const resetForm = () => {
    setTask({ taskName: "", teamMember: "", projectName: "", deadline: "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTask({ ...task, [name]: value });
  };

  useEffect(() => {
    if (isError) {
      setResponseError("Failed to add task!");
    } else {
      setResponseError("");
    }
  }, [isError]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    teamMember = teams?.find((t) => t.name === task?.teamMember);
    project = projects?.find((p) => p.projectName === task?.projectName);

    const data = {
      taskName: task?.taskName,
      teamMember: {
        id: teamMember?.id,
        name: task?.teamMember,
        avatar: teamMember?.avatar,
      },
      project: {
        id: project?.id,
        projectName: task?.projectName,
        colorClass: project?.colorClass,
      },
      deadline: task?.deadline,
      status: "pending",
    };
    const res = await addTask(data);
    if (res?.data) {
      resetForm();
      navigate("/");
    }
  };

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <div className="fieldContainer">
        <label htmlFor="lws-taskName">Task Name</label>
        <input
          type="text"
          name="taskName"
          id="lws-taskName"
          required
          placeholder="Implement RTK Query"
          value={task?.taskName}
          onChange={handleChange}
        />
      </div>

      <div className="fieldContainer">
        <label>Assign To</label>
        <select
          name="teamMember"
          id="lws-teamMember"
          value={task?.teamMember}
          onChange={handleChange}
          required
        >
          <option value="" hidden>
            Select Job
          </option>
          {teams?.map((team) => (
            <option key={team.id}>{team.name}</option>
          ))}
        </select>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lws-projectName">Project Name</label>
        <select
          id="lws-projectName"
          name="projectName"
          value={task?.projectName}
          onChange={handleChange}
          required
        >
          <option value="" hidden>
            Select Project
          </option>
          {projects?.map((project) => (
            <option key={project.id}>{project.projectName}</option>
          ))}
        </select>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lws-deadline">Deadline</label>
        <input
          type="date"
          name="deadline"
          id="lws-deadline"
          value={task?.deadline}
          onChange={handleChange}
          required
        />
      </div>

      <div className="text-right">
        <button type="submit" disabled={isLoading} className="lws-submit">
          Save
        </button>
      </div>
      {responseError && (
        <div className="text-right" style={{ color: "red" }}>
          {responseError}
        </div>
      )}
    </form>
  );
};

export default AddTaskForm;
